import type React from 'react';
import { MOBILE_GRADIENT_WIDTH } from '../constants/index.js';

interface VisibleDimensionsT {
  width: number;
  height: number;
}

interface CenterTabPropsT {
  e?: React.MouseEvent | React.FocusEvent;
  listRef: React.MutableRefObject<HTMLDivElement | null>;
}

export const isElementVisible = (tab: HTMLElement, tabList: HTMLElement): boolean => {
  const tabDimensions = tab.getBoundingClientRect();
  const tabListDimensions = tabList.getBoundingClientRect();

  return tabDimensions.left <= tabListDimensions.left
    ? tabListDimensions.left - tabDimensions.left <= tabDimensions.width
    : tabDimensions.right - tabListDimensions.right <= tabDimensions.width;
};

export const isElementVisibleCarousel = (
  tab: HTMLElement | null,
  tabContainer: HTMLDivElement | null,
  firstOrLastItem = true,
): boolean => {
  if (tab && tabContainer) {
    const tabDimensions = tab.getBoundingClientRect();
    const tabContainerDimensions = tabContainer.getBoundingClientRect();

    const offset = firstOrLastItem ? 16 : 32;
    const tabDimensionsLeft = Math.floor(tabDimensions.left - offset);
    const tabDimensionsRight = Math.floor(tabDimensions.right + offset);

    const tabContainerDimensionsLeft = Math.floor(tabContainerDimensions.left);
    const tabContainerDimensionsRight = Math.floor(tabContainerDimensions.right);

    return tabDimensionsLeft >= tabContainerDimensionsLeft && tabDimensionsRight <= tabContainerDimensionsRight;
  }
  return false;
};

export const centerTab = ({ e, listRef }: CenterTabPropsT) => {
  e?.persist();
  setTimeout(() => {
    if (listRef.current) {
      const { offsetLeft } = e?.target as HTMLButtonElement;
      const { width: tabWidth } = (e?.target as HTMLButtonElement).getBoundingClientRect();
      const { width: listWidth } = listRef.current.getBoundingClientRect();
      const extraSideSpace = listWidth - tabWidth;
      const leftOffsetToCenter = extraSideSpace > 0 ? extraSideSpace / 2 : 0;
      const centeredLeftOffset = offsetLeft > leftOffsetToCenter ? offsetLeft - leftOffsetToCenter : 0;
      listRef.current.scrollTo({
        top: 0,
        left: centeredLeftOffset,
        behavior: 'smooth',
      });

      e?.preventDefault();
    }
  }, 100);
};

export const getVisibleDimensions = (node: HTMLElement, referenceNode: HTMLElement): VisibleDimensionsT => {
  const nodeDimensions = node.getBoundingClientRect();
  const referenceNodeDimensions = referenceNode.getBoundingClientRect();

  return {
    width: Math.min(
      node.clientWidth,
      referenceNodeDimensions.left + referenceNode.clientWidth - nodeDimensions.left,
      node.clientWidth - (referenceNodeDimensions.left - nodeDimensions.left),
    ),
    height: Math.min(
      node.clientHeight,
      referenceNodeDimensions.top + referenceNode.clientHeight - nodeDimensions.top,
      node.clientHeight - (referenceNodeDimensions.top - nodeDimensions.top),
    ),
  };
};

export const shouldHaveLeftGradient = (scrollLeft: number): boolean => Math.abs(scrollLeft) > MOBILE_GRADIENT_WIDTH;

export const shouldHaveRightGradient = (scrollLeft: number, clientWidth: number, scrollWidth: number): boolean =>
  Math.abs(scrollLeft) <= scrollWidth - (clientWidth + MOBILE_GRADIENT_WIDTH);
